// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"3c5995d1","527":"93806d3b","896":"93806d3b"}[chunkId] + ".chunk.css";
};